export default __webpack_public_path__ + "static/media/poster.aa556751.jpeg";